export default "__VITE_PUBLIC_ASSET__41294b82__"